import { gql } from '@apollo/client';

/**
 * GraphQL query for pivot data
 */
export const PIVOT_QUERY = gql`
  query Pivot(
    $table: String!
    $rowDims: [String!]!
    $colDims: [String!]!
    $filters: [PivotFilterInput!]
    $measureId: String!
    $where: String!
  ) {
    pivot(
      table: $table
      rowDims: $rowDims
      colDims: $colDims
      filters: $filters
      measureId: $measureId
      where: $where
    ) {
      colTree {
        dimId
        value
        key
        childrenCount
        children {
          dimId
          value
          key
          childrenCount
          children {
            dimId
            value
            key
            childrenCount
          }
        }
      }
      rowLeaves {
        path {
          dimId
          value
        }
        key
        depth
      }
      cells {
        rowKey
        colKey
        value
      }
      totalCount
    }
  }
`;

/**
 * TypeScript interfaces matching GraphQL schema
 */
export interface PivotFilterInput {
  dimId: string;
  operator: 'eq' | 'neq' | 'in' | 'nin' | 'between' | 'gte' | 'lte' | 'notNull' | 'isNull';
  values: (string | number | null)[];
}

export interface PivotTreeNode {
  dimId: string;
  value: string | number | null;
  key: string;
  childrenCount: number;
  children?: PivotTreeNode[];
}

export interface PivotPathSegment {
  dimId: string;
  value: string | number | null;
}

export interface PivotRowLeaf {
  path: PivotPathSegment[];
  key: string;
  depth: number;
}

export interface PivotCell {
  rowKey: string;
  colKey: string;
  value: number;
}

export interface PivotResult {
  colTree: PivotTreeNode[];
  rowLeaves: PivotRowLeaf[];
  cells: PivotCell[];
  totalCount: number;
}

export interface PivotQueryVariables {
  table: string;
  rowDims: string[];
  colDims: string[];
  filters?: PivotFilterInput[];
  where?: string;
  measureId: string;
}

export interface PivotQueryResult {
  pivot: PivotResult;
}
